export default function() {
  var data = [];
  this.visit(function(node) {
    if (!node.length) do data.push(node.data); while (node = node.next)
  });
  return data;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-quadtree/src/data.js
// module id = 1894
// module chunks = 0